import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Checkbox,
  Radio,
  RadioGroup,
  Box,
  Select,
  Flex,
} from "@chakra-ui/react";
import ElementSettings from "./ElementSettings";
import { CheckIcon, CloseIcon, CopyIcon, DeleteIcon } from "@chakra-ui/icons";
import { getInitialValues } from "./constant";

interface FormElementProps {
  id: number;
  type: string;
  onDelete: (id: number) => void;
  setElements: React.Dispatch<React.SetStateAction<any[]>>;
}

const ElementContainer = ({
  open,
  onClose,
  type,
  id,
  setElements,
  elements,
  attributesData,
}: any) => {
  console.log("attributesData", attributesData);


  const [attributes, setAttributes] = useState<any>(
    attributesData.length > 0
      ? Object.keys(attributesData[0].attributes).length > 0
        ? attributesData[0].attributes
        : getInitialValues(type, id)
      : getInitialValues(type, id)
  );

  const handleDeleteElement = (id: any) => {
    setElements((prevElements: any) =>
      prevElements.filter((element: any) => element.id !== id)
    );
    handleModalClose();
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        console.log("ID copied to clipboard!", id);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleModalClose = () => {
    onClose();
  };

  // console.log("attributes", attributes);

  const handleAttributeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value, placeholder } = event.target;

    console.log("the name and value are", name, value, placeholder);

    setAttributes((prevAttributes: any) => ({
      ...prevAttributes,
      [name]: value,
      name: name,
      value: value,
      type: type,
    }));
  };

  const handleSubmit = () => {
    console.log("Attributes:", attributes);
    const dt = elements.findIndex((item: any) => item.id === id);

    if (dt !== -1) {
      console.log("Element index:", dt);

      // Create a new elements array with the updated attributes
      const updatedElements = elements.map((item: any, index: number) =>
        index === dt ? { ...item, attributes } : item
      );

      // Update the state with the new elements array
      setElements(updatedElements);
    }

    // Close the modal
    onClose();
  };

  return (
    <Modal isOpen={open} onClose={handleModalClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textTransform="capitalize">{type}</ModalHeader>
        <ModalCloseButton />
        {/* <ModalBody>{renderInputs()}</ModalBody> */}
        <ModalBody>
          <Box maxH="320px" p={2} overflowY="auto" className="customScrollBar">
            <ElementSettings
              type={type}
              id={id}
              elementValue={attributes}
              setElementValue={setAttributes}
              handleLabelChange={handleAttributeChange}
            />
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex gap={2}>
            <Button colorScheme="green" onClick={handleSubmit}>
              <Flex gap={2} alignItems="center">
                <CheckIcon /> Save
              </Flex>
            </Button>
            <Button onClick={handleCopy} colorScheme="blue">
              <CopyIcon />
            </Button>
            <Button onClick={() => handleDeleteElement(id)} colorScheme="red">
              <DeleteIcon />
            </Button>
            <Button onClick={handleModalClose} bg="gray.500" color="white">
              <CloseIcon />
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ElementContainer;
